<form role="form" [formGroup]="examTypeForm">
<h1 mat-dialog-title>EXAM TYPE</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Name of Exam Type</mat-label>
      <input matInput formControlName="name" placeholder="Enter exam type">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Enter a description of exam type">
    </mat-form-field>
  </p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addExamType()">Save</button>
</div>
</form>